import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import _ from "lodash";
import dayjs from "dayjs";
import { formatToCompanyTimezone } from "../../../../lib/functions";
import "../../../../components/common/bt.css"

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const BranchTransferTable = ({ printMode = false }) => {
  const { list, loading } = useSelector((state) => state.branchTransferList);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const totalAmount = _.sumBy(list, (r) => Number(r.tran_amount) || 0);

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    {
      title: "Date",
      dataIndex: "tran_date",
      render: (v) =>
    v ? formatToCompanyTimezone(v).split(" ")[0] : "-",
    },
    { title: "Branch Name", dataIndex: "name" },
    { title: "From Account", dataIndex: "from_acc_name" },
    { title: "To Account", dataIndex: "to_acc_name" },
    { title: "Tran By", dataIndex: "full_name" },
    {
      title: "Amount",
      dataIndex: "tran_amount",
      align: "right",
      render: (val) => fmt(val),
    },
  ];

  if (printMode) {
  return (
    <table className="bt-print-table">
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "20%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "10%" }} />
      </colgroup>

      <tbody>
        <tr className="bt-print-heading">
          <td>No.</td>
          <td>Date</td>
          <td>Branch Name</td>
          <td>From Account</td>
          <td>To Account</td>
          <td>Tran By</td>
          <td style={{ textAlign: "right" }}>Amount</td>
        </tr>

        {list.map((row, index) => (
          <tr key={row.id || index}>
            <td>{index + 1}</td>

            <td>
              {row.tran_date
                ? formatToCompanyTimezone(row.tran_date).split(" ")[0]
                : "-"}
            </td>

            <td>{row.name}</td>
            <td>{row.from_acc_name}</td>
            <td>{row.to_acc_name}</td>
            <td>{row.full_name}</td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.tran_amount)}
            </td>
          </tr>
        ))}

        <tr className="bt-print-total">
          <td colSpan={6} style={{ textAlign: "right" }}>
            Grand Total :
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(totalAmount)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(record, idx) => record.id || idx}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={6} align="right">
            <strong>Grand Total :</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6} align="right">
            <strong>{fmt(totalAmount)}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default BranchTransferTable;
